import { render, staticRenderFns } from "./Accordion.vue?vue&type=template&id=6506bffe&scoped=true&"
import script from "./Accordion.vue?vue&type=script&lang=js&"
export * from "./Accordion.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6506bffe",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6506bffe')) {
      api.createRecord('6506bffe', component.options)
    } else {
      api.reload('6506bffe', component.options)
    }
    module.hot.accept("./Accordion.vue?vue&type=template&id=6506bffe&scoped=true&", function () {
      api.rerender('6506bffe', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-274dllbdX03ZA/JS/comp/Accordion.vue"
export default component.exports